import React, { useMemo, useRef, useState } from "react";
import "./SpinWheel.css";
import pageBack from "../assets/wheel_back.jpg";

/** === 可調整資料 === */
const ITEMS = [
  "旅遊驚險季",
  "大庭廣眾丟臉事蹟",
  "工作出包",
  "荒唐約會事蹟",
  "學生時期中二黑歷史",
  "酒後大反差",
];
const COLORS = ["#D35151","#C79A3A","#3BAFD1","#2E9E7A","#D14B4B","#5A46B3"]; // 純色；如要半透明可改成 rgba


/** 幾何工具 */
const toRad = d => (d * Math.PI) / 180;
const polar = (cx, cy, r, deg) => {
  const t = toRad(deg);
  return [cx + r * Math.cos(t), cy + r * Math.sin(t)];
};
/** 扇形 path（以 12 點鐘方向為 -90°） */
const wedgePath = (cx, cy, r, a0, a1) => {
  const [x0,y0] = polar(cx,cy,r,a0);
  const [x1,y1] = polar(cx,cy,r,a1);
  const laf = (a1 - a0) <= 180 ? 0 : 1;
  return `M ${cx} ${cy} L ${x0} ${y0} A ${r} ${r} 0 ${laf} 1 ${x1} ${y1} Z`;
};

export default function SpinWheel() {
  const size = 520;                   // 轉盤 SVG 邊長
  const cx = size/2, cy = size/2;
  const R = size/2 - 12;              // 外半徑（扣邊框）
  const hubR  = 20;                   // 中央白圈半徑（可再調）
  const labelR = (R + hubR)/2 + 12;   // 文字半徑：落在每塊中線、內外之間偏外

  const sector = 360 / ITEMS.length;
  const textOffset = -30;

  const slices = useMemo(() => ITEMS.map((label,i) => {
    const a0 = -90 + i*sector;          // 讓第 0 塊從正上方開始
    const a1 = a0 + sector;
    const mid = (a0 + a1)/2 + textOffset;            // 該扇形的「中線角度」
    return { label, a0, a1, mid, color: COLORS[i % COLORS.length] };
  }), []);

  const wheelRef = useRef(null);
  const [deg, setDeg] = useState(0);
  const [spinning, setSpinning] = useState(false);
  const [result, setResult] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const spin = () => {
    if (spinning) return;
    setSpinning(true);
    setShowPopup(false);  // 再抽時收起彈窗

    const extra = 2000 + Math.floor(Math.random()*2000);
    const nextDeg = deg + extra;

    const g = wheelRef.current;                 // 旋轉整個群組
    g.style.transition = "transform 4s cubic-bezier(0.33,1,0.68,1)";
    g.style.transform  = `rotate(${nextDeg}deg)`;

    const onEnd = () => {
      // 小彈跳
      g.style.transition = "transform .18s";
      g.style.transform  = `rotate(${nextDeg + 6}deg)`;
      setTimeout(() => {
        g.style.transform = `rotate(${nextDeg - 6}deg)`;
        setTimeout(() => {
          g.style.transform = `rotate(${nextDeg}deg)`;
          setDeg(nextDeg);
          setSpinning(false);

          // 計算落點（指針固定在 12 點鐘方向）
          // 計算落點（指針固定在 12 點鐘）
            const a = ((nextDeg % 360) + 360) % 360;          // 0..360
            const seenFromTop = ( (360 - a + 90) % 360 );     // 以 12 點為 0°
            const index = Math.floor( (seenFromTop + sector / 2) / sector ) % ITEMS.length;
            //                   ↑↑ 關鍵：+ 半個扇形，避免卡在邊界落到隔壁區


          setResult(ITEMS[index]);
          setShowPopup(true);  // 常駐，直到下一次抽
        }, 180);
      }, 180);

      g.removeEventListener("transitionend", onEnd);
    };
    g.addEventListener("transitionend", onEnd, { once: true });
  };

  return (
    <div className="spin-page" style={{ "--page-back": `url(${pageBack})` }}>
      <div className="wheel-wrap">
        <div className="pointer" />

        <svg className="wheel-svg" width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          {/* 外框與陰影 */}
          <circle cx={cx} cy={cy} r={R + 6} fill="#000" opacity=".18" />
          <circle cx={cx} cy={cy} r={R} fill="#232323" stroke="#2f2f2f" strokeWidth="12" />

          {/* 會旋轉的群組：下層畫扇形，上層畫文字（文字永遠在上） */}
          <g ref={wheelRef} className="wheel-rot">
            {/* 下層：扇形 */}
            <g className="slices">
              {slices.map((s, i) => (
                <path
                  key={i}
                  d={wedgePath(cx, cy, R, s.a0, s.a1)}
                  fill={s.color}
                />
              ))}
            </g>

            {/* 上層：直式文字（置於各自扇形中線） */}
            <g className="labels" pointerEvents="none">
              {slices.map((s, i) => (
                <g key={i} transform={`rotate(${s.mid} ${cx} ${cy})`}>
                  <text
                    x={cx}
                    y={cy - labelR}
                    textAnchor="middle"
                    dominantBaseline="middle"
                    className="wheel-label-vertical"
                  >
                    {s.label}
                  </text>
                </g>
              ))}
            </g>
          </g>

          {/* 中央白圈（縮小版） */}
          <circle cx={cx} cy={cy} r={hubR} fill="#fff" stroke="#2f2f2f" strokeWidth="10" />
        </svg>
      </div>

      <button className="spin-btn" onClick={spin} disabled={spinning}>
        {spinning ? "Spinning..." : "Spin!"}
      </button>

      {/* 置中黑底白字彈窗（常駐，直到下一次抽） */}
      <div className={`popup-center ${showPopup ? "show" : ""}`}>
        <div className="popup-card">🎉 抽到：<b>{result}</b></div>
      </div>

      {/* 底部結果：往上＋變大，避免被忽略 */}
      <div className="result">{result && <>🎉 抽到：<b>{result}</b></>}</div>
    </div>
  );
}
